import { classes } from "@/utils"

/**
 * Badge for an accounting item (product/service) — the thing that actually appears on the credit
 * memo line in QuickBooks/NetSuite. Renders nothing when the item is missing/blank.
 */
export function ItemBadge({ item, className }: { item?: string | null; className?: string }) {
  const name = item?.trim()
  if (!name) {
    return null
  }
  return (
    <span
      class={classes(
        "inline-flex items-center rounded-full bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-600/20",
        className
      )}
      title="Item — what appears on the credit memo line in your accounting system">
      {name}
    </span>
  )
}
